const dependencyArray = [
  // ────────────── paymentDetailsSection0 ──────────────
  {
    key: "paymentMethod",
    section: "paymentDetailsSection0",
    keys: ["bankDetails", "creditCardDetails", "checkDetails"]
  },

  // ────────────── careStatusSection0 ──────────────
  { key: "hospiceStatus", section: "careStatusSection0" },
  { key: "homeHealthStatus", section: "careStatusSection0" },

  // ────────────── variableFlexibleServices ──────────────
  {
    key: "eating",
    section: "variableFlexibleServices",
    keys: ["assistanceEatingNotes"]
  },
  {
    key: "other",
    section: "variableFlexibleServices",
    keys: ["specifyOther"]
  },

  // ────────────── clientCareNeeds ──────────────
  {
    key: "isShoweringAssistance",
    section: "clientCareNeeds",
    keys: ["isShoweringAssistanceLevel"]
  },
  {
    key: "isMedicationReminders",
    section: "clientCareNeeds",
    keys: ["isMedicationRemindersResponse"]
  },
  {
    key: "swallowing",
    section: "clientCareNeeds",
    keys: ["swallowingOther"]
  },
  {
    key: "isMealtimeAssistance",
    section: "clientCareNeeds",
    keys: ["isMealtimeAssistanceLevel"]
  },

  // ────────────── additionalInformation ──────────────
  {
    key: "longTermCareInsurance",
    section: "additionalInformation",
    keys: ["policyNumber", "ltcInsuranceProvider", "ltcInsuranceAcknowledgment"]
  },
  {
    key: "firearmsPresent",
    section: "additionalInformation",
    keys: ["firearmsSecure"]
  },
  {
    key: "petsPresent",
    section: "additionalInformation",
    keys: ["petDetails"]
  },

  // ────────────── billingInfoSection0 ──────────────
  {
    key: "recipientType",
    section: "billingInfoSection0",
    keys: ["billingContactFirstName"]
  },

  // ────────────── emergencyPlanningSection0 ──────────────
  {
    key: "stearRegistration",
    section: "emergencyPlanningSection0",
    keys: ["notes"]
  },

  // ────────────── contacts ──────────────
  {
    key: "contactRelationship",
    section: "contacts",
    keys: ["otherSpecify", "facilityAddress", "zipCode"]
  },

  // ────────────── formSubmissionDetails ──────────────
  {
    key: "isFillingForSomeoneElse",
    section: "formSubmissionDetails",
    keys: ["fillerIdentity"]
  },

  // ────────────── behaviorCognition ──────────────
  {
    key: "confusion",
    section: "behaviorCognition",
    keys: ["confusionNotes"]
  },
  {
    key: "agitation",
    section: "behaviorCognition",
    keys: ["agitationNotes"]
  },
  {
    key: "suspicious",
    section: "behaviorCognition",
    keys: ["suspiciousNotes"]
  },
  {
    key: "upAtNight",
    section: "behaviorCognition",
    keys: ["upAtNightNotes"]
  },
  {
    key: "withdrawn",
    section: "behaviorCognition",
    keys: ["withdrawnNotes"]
  },
  {
    key: "wanders",
    section: "behaviorCognition",
    keys: ["wandersNotes"]
  },
  {
    key: "combative",
    section: "behaviorCognition",
    keys: ["combativeNotes"]
  },
  {
    key: "allergies",
    section: "additionalInformation",
    keys: ["allergiesNote"]
  }
];

export default dependencyArray;
